<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kWBzlu/tc-custom/9780358525905.jpg?1716663321356" alt="This image is the cover for the book Best American Mystery And Suspense 2021, The Best American Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best American Mystery And Suspense 2021, The Best American Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Steph Cha, a rising star who brings a fresh perspective as series editor, takes the helm of the new <i>The </i><i>Best American Mystery and Suspense</i>, with best-selling crime novelist Alafair Burke joining her as the first guest editor.</b><p>“Crime writers, forgive the pun, are killing it right now creatively,” writes guest editor Alafair Burke in her introduction. “It was difficult—painful even—to narrow this year’s Best American Mystery and Suspense to only twenty stories.” Spanning from a mediocre spa in Florida, to New York’s gritty East Village, to death row in Alabama, this collection reveals boundless suspense in small, quiet moments, offering startling twists in the least likely of places. From a powerful response to hateful bullying, to a fight for health care, to a gripping desperation to vote, these stories are equal parts shocking, devastating, and enthralling, revealing the tension pulsing through our everyday lives and affirming that mystery and suspense writing is better than ever before.</p><p><b>The Best American Mystery and Suspense 2021includes<br/> JENNY BHATT• GAR ANTHONY HAYWOOD• GABINO IGLESIAS• AYA DE LEÓN• LAURA LIPPMAN DELIA C. PITTS• ALEX SEGURA• FAYE SNOWDEN• LISA UNGER and others</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steph Cha, Alafair Burke
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72c711ea